export const requestStatus = {
  "ALL": [
    {text: "Chờ xác nhận", value: 1, role: 1},
    {text: "Chờ phê duyệt", value: 2, role: 1},
    {text: "Không phê duyệt", value: 3, role: 1},
    {text: "Đã phê duyệt", value: 4, role: 1},
    {text: "Chưa hoàn thành nhập kho", value: 5, role: 1},
    {text: "Hoàn thành nhập kho", value: 6, role: 1},
  ],
  "DIRECTOR":[
    {text: "Chờ phê duyệt", value: 2, role: 1},
    {text: "Không phê duyệt", value: 3, role: 1},
    {text: "Đã phê duyệt", value: 4, role: 1},
    {text: "Chưa hoàn thành nhập kho", value: 5, role: 1},
    {text: "Hoàn thành nhập kho", value: 6, role: 1},
  ],
  "BUY": [
    {text: "Đã phê duyệt", value: 4, role: 1},
    {text: "Chưa hoàn thành nhập kho", value: 5, role: 1},
  ],
  "STATUS": { WAIT_CHECK:1,
      WAIT_APPROVE: 2,
      REJECT: 3,
      APPROVED: 4,
      NOT_IN_WAREHOUSE: 5,
      COMPLETED: 6
    },
};

export const requestImportStatus = [
  { text: "Chưa giao hàng", value: 1 },
  { text: "Đã giao hàng", value: 2 },
];

export const requestExportStatus = [
  { text: "Chờ xác nhận", value: 1 },
  { text: "Chờ phê duyệt", value: 2 },
  { text: "Không phê duyệt", value: 3 },
  { text: "Đã phê duyệt", value: 4 },
  { text: "Chưa hoàn thành xuất kho", value: 5 },
  { text: "Hoàn thành xuất kho", value: 6 },
];

export const importWhStatus = [
  { text: "Chờ xác nhận", value: 1 },
  { text: "Chờ phê duyệt", value: 2 },
  { text: "Không phê duyệt", value: 3 },
  { text: "Đã phê duyệt", value: 4 },
  { text: "Đã hoàn trả", value: 5 },
];

export const importWhStatusCons =  {
  'waitConfirm': 1,
  'waitApprove': 2,
  'rejected': 3,
  'approved': 4,
  'returned': 5,
};

export const acceptanceReportStatus = [
  { text: "Chờ xác nhận", value: 1 },
  { text: "Chờ phê duyệt", value: 2 },
  { text: "Không phê duyệt", value: 3 },
  { text: "Đã phê duyệt", value: 4 },
];

export const acceptanceReportStatusCons =  {
  'waitConfirm': 1,
  'waitApprove': 2,
  'rejected': 3,
  'approved': 4,
};

export const repairRequestStatus = [
  { text: "Chờ phê duyệt", value: 1 },
  { text: "Không phê duyệt", value: 2 },
  { text: "Đã phê duyệt", value: 3 },
  { text: "Đã xuất kho sửa chữa", value: 4 },
  { text: "Chờ nhập lại kho", value: 6 },
  { text: "Đã nhập kho", value: 5 },
];
export const repairRequestStatusCons =  {
  'waitApprove': 1,
  'rejected': 2,
  'approved': 3,
  'exported': 4,
  'waitImport': 6,
  'imported': 5,
};

export const importRepairRequestStatus = [
  { text: "Chờ xác nhận", value: 1 },
  { text: "Chờ phê duyệt", value: 2 },
  { text: "Đã phê duyệt", value: 3 },
];
export const importRepairRequestStatusCons =  {
  'waitAccept': 1,
  'waitApprove': 2,
  'approved': 3,
};